import { PetCounts, PetType } from './Pet';

export enum RoverBrand {
  CatInAFlat = 'catinaflat', // catinaflat.com
  DogBuddy = 'dogbuddy', // dogbuddy.com
  MadPaws = 'madpaws', // madpaws.com.au
  Rover = 'rover', // rover.com
}

export enum RoverBrandAriaLabel {
  Rover = 'Rover',
  CatInAFlat = 'Cat in a Flat',
  MadPaws = 'Mad Paws',
}

export type RoverBrandContextType = {
  brand: RoverBrand;
};

export type RoverBrandSettings = {
  isSitterEnabled: boolean;
  isFlexibleDropInEnabled: boolean;
  enableSitterProfileRichResults: boolean;
};

export type RoverBrandProviderProps = {
  brand?: RoverBrand;
  children: React.ReactNode;
};

export const RoverBrandPetType = {
  [RoverBrand.Rover]: [PetType.DOG, PetType.PUPPY, PetType.CAT],
  [RoverBrand.DogBuddy]: [PetType.DOG, PetType.PUPPY],
  [RoverBrand.MadPaws]: [PetType.DOG, PetType.PUPPY, PetType.CAT],
  [RoverBrand.CatInAFlat]: [PetType.CAT],
};

export const RoverBrandDefaultPetCounts: Record<RoverBrand, PetCounts> = {
  [RoverBrand.Rover]: { dogCount: 1, catCount: 0, puppyCount: 0 },
  [RoverBrand.DogBuddy]: { dogCount: 1, catCount: 0, puppyCount: 0 },
  [RoverBrand.MadPaws]: { dogCount: 1, catCount: 0, puppyCount: 0 },
  [RoverBrand.CatInAFlat]: { dogCount: 0, catCount: 1, puppyCount: 0 },
};
